import React from "react";

interface VideoTimelineProps {
    fillPercentage: number;
    height: number;
}

export const VideoProgressBar = ({ fillPercentage, height }: VideoTimelineProps): JSX.Element => {
    return (
        <div
            className="percent-bar"
            style={{
                width: `${fillPercentage}%`,
                height,
                backgroundColor: "#0076EC",
                position: "absolute"
            }}
        ></div>
    );
};
